import { getAuthTokens, default as useAuthStore } from "@/store/useAuthStore";
import { AI_AGENT_API, SERVER_API } from "@/utils/constants";
import { ApiService } from "@/services/api-service";
import { ApiService } from "@/services/api-service";
import axios from "axios";

// === Helper to refresh token ===
const refreshAuthToken = async () => {
  try {
    const response = await ApiService.refreshToken();
    const newToken = response?.token;

    if (newToken) {
      useAuthStore.setState({
        authTokens: {
          token: newToken,
          refreshToken: getAuthTokens()?.refreshToken,
        },
      });
    }

    return newToken;
  } catch (error) {
    console.error("Token refresh failed", error);
    useAuthStore.getState().logout(); // force logout on refresh failure
    return null;
  }
};

const addAuthHeader = async (config: any) => {
  const authTokens = getAuthTokens();
  if (authTokens) {
    config.headers.Authorization = `Bearer ${authTokens.token}`;
  }
  return config;
};

const handleAuthError = async (error: any) => {
  const originalRequest = error.config;

  if (
    (error.response?.status === 401 || error.response?.status == 403) &&
    !originalRequest._retry
  ) {
    originalRequest._retry = true;
    const newToken = await refreshAuthToken();

    if (newToken) {
      originalRequest.headers.Authorization = `Bearer ${newToken}`;
      return axios(originalRequest);
    }
  } else if (error.response?.status == 404) {
    useAuthStore.getState().logout();
  }

  return Promise.reject(error);
};

export const aiApi = axios.create({
  baseURL: AI_AGENT_API,
  timeout: 60000,
});

aiApi.interceptors.request.use(addAuthHeader, Promise.reject);
aiApi.interceptors.response.use((res) => res, handleAuthError);

export const authApi = axios.create({
  baseURL: SERVER_API,
  timeout: 60000,
});

authApi.interceptors.request.use(addAuthHeader, Promise.reject);
authApi.interceptors.response.use((res) => res, handleAuthError);
